import React, { Fragment } from 'react';
import pt from 'prop-types';

import Button from 'components/button';
import Link from 'components/link';
import { Form, Field } from 'components/form';
import { FadeInPop } from 'components/transitions';
import OAuthButtons from 'components/login/oauth-buttons';
import {
  CreateAccountFields,
  SignInFields,
  RecoverNote,
} from 'components/login/account-fields';

import './signup.scss';

const { GOOGLE_CLIENT_ID, GITHUB_CLIENT_ID } = process.env;
const HAS_OAUTH_PROVIDERS = Boolean(GOOGLE_CLIENT_ID || GITHUB_CLIENT_ID);

const JOIN_OPTIONS = Object.freeze([
  { value: 'new', label: "I'm new here" },
  { value: 'existing', label: 'I have an account' },
]);

export default class SignupAccount extends React.PureComponent {
  static propTypes = {
    companyName: pt.string,
    onSubmit: pt.func,
    onBack: pt.func,
    onStartOAuth: pt.func,
    canGoBack: pt.bool,
  };

  state = { tab: 'new' };

  onChangeTab = (event, tab) => {
    this.setState({ tab });
  };

  onCaptureOAuthClick = () => {
    this.props.onStartOAuth();
  };

  // The tab field is readonly, and the form leaves those out of what it submits
  onSubmitForm = (values) => {
    return this.props.onSubmit({ ...values, tab: this.state.tab });
  };

  renderSubheading() {
    return (
      <div className="signup-header">
        <div className="signup-subtitle">
          Set up access to your <b>{this.props.companyName}</b> partner account
        </div>
      </div>
    );
  }

  render() {
    const { onBack, canGoBack = true } = this.props;
    const { tab } = this.state;

    return (
      <FadeInPop>
        <div>
          {this.renderSubheading()}

          <Form onSubmit={this.onSubmitForm} autoFocus={true}>
            <Field
              type="radio"
              name="tab"
              className="login-join-tabs login-form-field-margin-24"
              options={JOIN_OPTIONS}
              onChange={this.onChangeTab}
              defaultValue={tab}
              buttons
              readonly
            />

            {tab === 'new' ? (
              <CreateAccountFields />
            ) : (
              <SignInFields showRecover={false} />
            )}

            <div className="signup-actions">
              <Button size="large" type="submit" className="signup-submit">
                Create partner account
              </Button>

              {tab === 'existing' && <RecoverNote />}
            </div>
          </Form>

          {HAS_OAUTH_PROVIDERS && (
            <Fragment>
              <div className="oauth-buttons_divider">
                <span>or</span>
              </div>

              <div onClickCapture={this.onCaptureOAuthClick}>
                <OAuthButtons flow="signup" />
              </div>
            </Fragment>
          )}

          {canGoBack && (
            <Link className="signup-back" onClick={onBack}>
              ← Back to previous step
            </Link>
          )}
        </div>
      </FadeInPop>
    );
  }
}
